/** @type {import('./$types').PageLoad} */
export function load({ params }) {
	return {
		meta_title: `CV: cpf.sh`,
		heading: `This is my CV`,
		social_title: "CV: cpf.sh",
		description:
			"I'm an interdisciplinary professional with clinical, technical, and academic experience across pre-hospital emergency care, web software engineering, and human-computer interaction."
	};
}
